<section class="intro">
  <div class="bg-image h-100"
    style="background-image: url('https://mdbootstrap.com/img/Photos/new-templates/glassmorphism-article/img5.jpg');">
    <!--  
      <div class="mask d-flex align-items-center h-100">-->
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-10 col-lg-7 col-xl-5 login">
          <div class="card mask-custom">
            <div class="card-body p-5 text-white">

              <div class="my-4">

                <h2 class="text-center mb-5">Login</h2>

                <form [formGroup]="form" (ngSubmit)="onSubmit()">
                  <div class="row m-2">
                    <div class="col-md-12">
                      <mdb-form-control>
                        <input mdbValidate mdbInput type="email" id="email" class="form-control" formControlName="email"
                          required />
                        <label mdbLabel class="form-label" for="email">E-mail</label>
                        <mdb-error *ngIf="email?.invalid && (email?.dirty || email?.touched)">
                          Errore compilazione E-mail</mdb-error>
                        <mdb-success *ngIf="email?.valid && (email?.dirty || email?.touched)">
                          Email OK!</mdb-success>

                      </mdb-form-control>
                    </div>
                  </div>
                  <div class="row m-2">
                    <div class="col-md-12 mt-3">
                      <mdb-form-control>
                        <input mdbValidate mdbInput type="password" id="password" class="form-control"
                          formControlName="password" required />
                        <label mdbLabel class="form-label" for="email">Password</label>
                        <mdb-error *ngIf="password?.invalid && (password?.dirty || email?.touched)">
                          Errore Password (lunghezza minima 6 caratteri)</mdb-error>
                        <mdb-success *ngIf="password?.valid && (password?.dirty || password?.touched)">
                          Password OK!</mdb-success>
                      </mdb-form-control>
                    </div>

                  </div>
                  <div *ngIf="divKO" class="row m-2">
                    <div class="col-md-12 mt-3 ">
                      <div class="alert alert-danger" role="alert">{{messageKO}}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 d-flex justify-content-end">
                      <button type="submit" class="btn btn-primary mt-4">Login</button>
                    </div>
                  </div>


                  <div class="row mt-5">
                    <div class="col-md-12 ">

                      <a class="link-light fs-6" [routerLink]="['/cambiaPassword']">Password
                        dimenticata?</a>
                    </div>

                  </div>
                </form>


              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>